const softCheckInitialState = {
    isPending: false,
    consents: {
        acceptedIncomeCheck: false,
        acceptedSoftCheck: false,
    },
    isError: false,
    errorMessage: '',
    decision: '',
    maxLendAmount: {
        amount: 0,
        currency: 'gbp',
    },
    data: {},
};

export default softCheckInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/softCheckInitialState.js